import { normalize } from "./normalizeString";

const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const regexify = (searchTerm: string): RegExp => {
  const normalizedSearchTerm = normalize(searchTerm);
  const escapedSearchTerm = escapeRegExp(normalizedSearchTerm);

  try {
    const result = escapedSearchTerm
      .replace(/.{1}/g, "($&|[^a-zA-Z0-9])") // any character can be substituted for non-alphanumeric characters
      .replace(/.{16}/g, "$&[^a-zA-Z0-9]?"); // allow any non alphanumeric character after each original character

    return new RegExp(result, "gi");
  } catch (error) {
    // Fallback to a simple escaped regex if the complex pattern fails
    return new RegExp(escapedSearchTerm, "gi");
  }
};
